import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { get, post, put } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  addData: {},
  sorted: [],
  selectedLocation: {},
};

const slice = createSlice({
  name: 'Locations',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    // GET LocationManagement
    selectGlobalLocation(state, action) {
      state.selectedLocation = action.payload;
    },

    // GET LocationManagement
    getLocationsSuccess(state, action) {
      state.data = action.payload.data;
    },

    addOrUpdateLocations(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function selectGlobalLocation(selectedLocation) {
  dispatch(slice.actions.selectGlobalLocation(selectedLocation));
}

export function getLocations() {
  return async () => {
    try {
      const response = await get(`location`);
      if (response.status) {
        dispatch(slice.actions.getLocationsSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addLocation(body) {
  return async () => {
    try {
      const response = await post(`location`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateLocations(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateLocation(body) {
  return async () => {
    try {
      const response = await put(`location`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateLocations(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
